import React from 'react';
import { getWalletIcon } from '../../utils/withdrawalWallets';

const WalletMethodIcon = ({
  iconUrl = '',
  methodKey = '',
  className = 'w-5 h-5',
  imgClassName = 'w-8 h-8 object-contain',
  iconClassName = '',
}) => {
  if (iconUrl) {
    return <img src={iconUrl} alt="" className={imgClassName || className} />;
  }

  const Icon = getWalletIcon(methodKey);
  return <Icon className={iconClassName || className} />;
};

export default WalletMethodIcon;
